import { useState } from "react";
import { TextField, Checkbox } from "@lannister/duplo";

import { ReactComponent as CardIcon } from "../../assets/icons/card.svg";
import { ReactComponent as CalendarIcon } from "../../assets/icons/calendar.svg";
import { ReactComponent as EyeOffIcon } from "../../assets/icons/eye-slash.svg";
import { ReactComponent as EyeOnIcon } from "../../assets/icons/eye.svg";

import { ValidateNumeric, FormatExpiryDate, FormatCardNumber } from "./utils";

const CardDetailsForm = ({ handleChange, isSaveCardOptionEnabled }) => {
  const [showCVV, setShowCVV] = useState(false);
  const [shouldSaveCard, setShouldSaveCard] = useState(false);
  const [cardData, setCardData] = useState({});

  const toggleCvvVisibility = () => {
    setShowCVV((prev) => !prev);
  }

  const onFieldChange = (field, value) => {
    setCardData(prev => ({ ...prev, [field]: value }));
    handleChange(field, value);
  }

  const onChangeShouldSaveCard = (value) => {
    setShouldSaveCard(value);
    onFieldChange("should_save_payment_method", value);
  }

  return (
        <div style={styles.card}>
          <div style={styles.row}>
              <div style={styles.field}>
                  <TextField
                    label="First Name"
                    value={cardData.first_name}
                    onChange={e => onFieldChange("first_name", e.target.value)}
                    maxLength={50}
                  />
              </div>
              <div style={styles.field}>
                  <TextField
                    label="Last Name"
                    value={cardData.last_name}
                    onChange={e => onFieldChange("last_name", e.target.value)}
                    maxLength={50}
                  />
              </div>
          </div>

          <TextField
              label="Card Number"
              value={cardData.payment_number}
              onChange={e => onFieldChange("payment_number", e.target.value)}
              rightIcon={<CardIcon />}
              maxLength={19}
              onInput={
                (event) => {
                  ValidateNumeric(event);
                  FormatCardNumber(event);
                }}
          />

          <div style={styles.row}>
              <div style={styles.field}>
                  <TextField
                    label="MM/YY"
                    value={cardData.expiry_date}
                    onChange={e => onFieldChange("expiry_date", e.target.value)}
                    rightIcon={<CalendarIcon />}
                    maxLength={5}
                    onInput={
                      (event) => {
                        ValidateNumeric(event);
                        FormatExpiryDate(event, cardData.expiry_date);
                      }}
                  />
                  {isSaveCardOptionEnabled &&
                    <Checkbox
                      label="Save Card"
                      checked={shouldSaveCard}
                      onChange={(value) => onChangeShouldSaveCard(value)} />}
              </div>
              <div style={styles.field}>
                  <TextField
                    label="CVV"
                    value={cardData.cvv}
                    onChange={e => onFieldChange("cvv", e.target.value)}
                    rightIcon={
                      <span onClick={toggleCvvVisibility} style={{ cursor: "pointer" }}>
                        {showCVV ? <EyeOnIcon /> : <EyeOffIcon />}
                      </span>}
                    onInput={(event) => ValidateNumeric(event)}
                    maxLength={3}
                    type={showCVV ? "text" : "password"}
                  />
              </div>
          </div>
        </div>
  );
};

const styles = {
  card: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  row: {
    display: "flex",
    gap: "12px",
  },
  field: {
    flex: 1,
    minWidth: 0,
  },
};

export default CardDetailsForm;
